import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "ml-4",
  style: {"font-size":"1.3em"}
}
const _hoisted_2 = { class: "d-inline-block" }

import { ref, computed } from 'vue';
import { useSalesStore } from '@/store/sales';
import { useQuotationsStore } from '@/store/quotations';
import { useReportsStore } from '@/store/reports'; // 👈 nuevo store

import SubIvaTotalVue from '@/components/reports/cards/SubIvaTotal.vue';
import ReportFilterDate from '@/components/filters/date/Container.vue'
import ProspectsVsClients from '@/components/reports/charts/QuotedProspectsVsClients.vue'
import ProspectsByStatus from '@/components/reports/charts/ProspectsByStatus.vue'
import SoldByUser from '@/components/reports/charts/SoldByUser.vue'
import QuotedByUser from  '@/components/reports/charts/QuotedByUser.vue'
import SalesByMedium from  '@/components/reports/charts/SalesByMedium.vue'
import SalesByProducts from  '@/components/reports/charts/SalesByProducts.vue'

// Stores

export default /*@__PURE__*/_defineComponent({
  __name: 'Container',
  setup(__props) {

const salesStore = useSalesStore();
const quotationsStore = useQuotationsStore();
const reportsStore = useReportsStore();

// Datos actuales de tus stores
const salesTotalsData = computed(() => salesStore.sales_totals);
const quotationsTotalsData = computed(() => {
  const raw = quotationsStore.quotations_totals;
  if (Array.isArray(raw)) return raw[0] || null;
  return raw;
});
const prospectsVsClientsData = computed(() => quotationsTotalsData.value?.totals_by_subject_type ?? {});
const prospectsByStatusData = computed(() => quotationsTotalsData.value?.sums_by_opportunity_status ?? {});
const sold_by_user = computed(() => salesStore.sold_by_user);
const quoted_by_user = computed(() => quotationsStore.quoted_by_user);
const sold_by_medium = computed(() => salesStore.sold_by_medium);
const sold_by_product = computed(() => salesStore.sold_by_product);

// Filtro de fechas
const filter = ref<[string, string]>(['', '']);
const handleRangeUpdated = async (range: { start: Date, end: Date } | null) => {
  let params = {};
  if (range) {
    const from = range.start.toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).slice(0, 10);
    const to = range.end.toLocaleString("sv-SE", { timeZone: "America/Monterrey" }).slice(0, 10);
    if (filter.value[0] !== from || filter.value[1] !== to) {
      filter.value = [from, to];
      params = { from, to };
    } else {
      return;
    }
  } else {
    filter.value = ['', ''];
  }
  await Promise.all([
    salesStore.soldByUser(params),
    salesStore.soldByMedium(params),
    salesStore.soldByProduct(params),
    salesStore.salesTotals(params),
    quotationsStore.quotedByUser(params),
    quotationsStore.quotationsTotals(params)
  ]);
};

// Modo oscuro (ya lo tienes)
const isDarkMode = ref(window.matchMedia('(prefers-color-scheme: dark)').matches);
window.matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', e => isDarkMode.value = e.matches);

// Loading states
const loadingPDF = ref(false);
const loadingExcel = ref(false);
const isLoading = computed(() => loadingPDF.value || loadingExcel.value);
const loadingLabel = computed(() => loadingPDF.value ? 'Exportando PDF...' : loadingExcel.value ? 'Exportando Excel...' : '');

// Parámetros para export
const scope = ref<'team_and_all_sellers' | 'team_only' | 'me'>('team_and_all_sellers'); // ajusta si tienes UI para esto
const exportParams = computed(() => ({
  from: filter.value[0] || undefined,
  to: filter.value[1] || undefined,
  scope: scope.value
}));

// Exportar vía backend
const exportToPDF = async () => {
  loadingPDF.value = true;
  try {
    await reportsStore.exportPDF(exportParams.value);
  } finally {
    loadingPDF.value = false;
  }
};

const exportToExcel = async () => {
  loadingExcel.value = true;
  try {
    await reportsStore.exportExcel(exportParams.value);
  } finally {
    loadingExcel.value = false;
  }
};

const getHostnameSafe = (): string => {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname;
  }
  return process.env.VITE_PUBLIC_HOST ?? process.env.SSR_HOST ?? '';
};
const IS_DOMINIOMEDIOS = getHostnameSafe() === 'crm.dominiomedios.com';

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_overlay, {
        modelValue: isLoading.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLoading).value = $event)),
        "z-index": 99999,
        class: "d-flex align-center justify-center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            size: "64",
            color: "primary"
          }),
          _createElementVNode("span", _hoisted_1, _toDisplayString(loadingLabel.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_row, { class: "ma-0" }, {
        default: _withCtx(() => [
          _createVNode(ReportFilterDate, {
            onRangeUpdated: handleRangeUpdated,
            style: {"width":"calc(100% - 70px)"}
          }),
          _createElementVNode("span", _hoisted_2, [
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "bottom",
              disabled: !filter.value[0]==''
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "Selecciona un rango de fechas para exportar", -1)
              ])),
              _: 1,
              __: [1]
            }, 8, ["disabled"]),
            _createVNode(_component_v_menu, {
              "open-on-hover": "",
              disabled: isLoading.value || filter.value[0]==''
            }, {
              activator: _withCtx(({ props: menuProps }) => [
                _createElementVNode("span", _normalizeProps(_guardReactiveProps(menuProps)), [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    size: "small",
                    class: "mt-lg-2 mx-3",
                    variant: "text",
                    disabled: isLoading.value || filter.value[0]=='',
                    "aria-label": "Descargar reporte"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-download")
                        ])),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ], 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, { onClick: exportToPDF }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("Exportar PDF")
                      ])),
                      _: 1,
                      __: [3]
                    }),
                    _createVNode(_component_v_list_item, { onClick: exportToExcel }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode("Exportar Excel")
                      ])),
                      _: 1,
                      __: [4]
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_v_container, { class: "pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(SubIvaTotalVue, {
                cols: 4,
                records: salesTotalsData.value
              }, null, 8, ["records"]),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "8",
                    class: "px-0 px-lg-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SoldByUser, { data: sold_by_user.value }, null, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    md: "4",
                    class: "px-0 px-lg-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SalesByMedium, { data: sold_by_medium.value }, null, 8, ["data"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              IS_DOMINIOMEDIOS
                ? (_openBlock(), _createBlock(SalesByProducts, {
                    key: 0,
                    data: sold_by_product.value
                  }, null, 8, ["data"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "7",
                    class: "px-0 px-lg-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(QuotedByUser, { data: quoted_by_user.value }, null, 8, ["data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    md: "5",
                    class: "px-0 px-lg-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SubIvaTotalVue, {
                        class: "pt-4",
                        cols: 2,
                        records: quotationsTotalsData.value
                      }, null, 8, ["records"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "ma-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    md: "4",
                    class: "px-0 px-lg-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ProspectsVsClients, {
                        style: _normalizeStyle(isDarkMode.value?'background:#212121; border-radius: 4px; padding:20px 0px;':'margin-top:20px;'),
                        data: prospectsVsClientsData.value
                      }, null, 8, ["style", "data"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    md: "8",
                    class: "px-0 px-lg-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ProspectsByStatus, { data: prospectsByStatusData.value }, null, 8, ["data"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})